import React from "react";

function Document() {
  return (
    <div>
      <h2>Document</h2>
    </div>
  );
}

export default Document;
